/**
 * Pause a GSAP timeline while its target is off-screen.
 * Uses tl.pause()/resume() so it doesn't fight timeScale-based hover state.
 * Returns a disconnect() function.
 */
export function pauseWhenOffscreen(rootEl, tl, { rootMargin = '200px', onExit } = {}) {
  if (!rootEl || !tl || typeof IntersectionObserver === 'undefined') {
    return () => {}
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        tl.resume()
      } else {
        tl.pause()
        if (typeof onExit === 'function') onExit(entry.target)
      }
    })
  }, { root: null, rootMargin, threshold: 0 })

  observer.observe(rootEl)

  return () => observer.disconnect()
}

export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
